import { closestTag, findMatchingEvents, getElementText } from './woopraHelpers';

let _initialised = false;
export const initWoopraCustomEvents = () => {
  if (_initialised) return;
  _initialised = true;

  document.addEventListener('click', e => {
    if (!window.woopra) return;

    const pathname = window.location.pathname;
    const target = e.target;
    const anchor = closestTag(target, 'a');
    if (anchor) {
      const matches = findMatchingEvents(pathname, 'link');
      matches.forEach(({ eventName }) => {
        window.woopra.track(eventName, {
          url: window.location.href,
          element_type: 'link',
          element_text: getElementText(anchor),
          href: anchor.getAttribute('href') || '',
        });
      });
    }

    const button = !anchor && closestTag(target, 'button');
    if (button) {
      const matches = findMatchingEvents(pathname, 'button');
      matches.forEach(({ eventName }) => {
        window.woopra.track(eventName, {
          url: window.location.href,
          element_type: 'button',
          element_text: getElementText(button),
        });
      });
    }

    if (!button && !anchor) {
      const roleButton = target.closest && target.closest('[role="button"]');
      if (roleButton) {
        const matches = findMatchingEvents(pathname, 'button');
        matches.forEach(({ eventName }) => {
          window.woopra.track(eventName, {
            url: window.location.href,
            element_type: 'button',
            element_text: getElementText(roleButton),
          });
        });
      }
    }
  });

  document.addEventListener(
    'submit',
    () => {
      if (!window.woopra) return;

      const pathname = window.location.pathname;
      const matches = findMatchingEvents(pathname, 'submit');
      matches.forEach(({ eventName }) => {
        window.woopra.track(eventName, {
          url: window.location.href,
          element_type: 'form',
        });
      });
    },
    true /* capture – fire before preventDefault */
  );
};
